export enum PatientSex {
    Male = 'male',
    Female = 'female',
}
